import axios from "axios";
import store from "@/store";
import {
  Dialog,
  Toast
} from "vant";
const request = axios.create({
  //  baseURL: "https://mapi.plus.hugd.com",
  // baseURL: "http://flash-sale-backend-test.zhijianmedia.cn:18083",
  baseURL: process.env.VUE_APP_BASE_URL

  // baseURL: "http://flash-sale-backend.zhijianmedia.cn:8083",
  // timeout: 6000
});

request.interceptors.request.use(
  (config) => {
    // if (!store.state.nthUserInfo) {
    //   Dialog.alert({
    //     title: "警告",
    //     message: "请先登录南太湖号",
    //   }).then(() => {
    //     SmartCity.goLogin();
    //   });
    // }

    // console.log(process.env.VUE_APP_BASE_URL);

    // console.log(store.state.token);
    config.headers.token = store.state.token;


    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    if (response.data.code != 200) {


      if (response.data.code == 200002 || response.data.code == 200004 || response.data.code == 200005 ||response.data.code == 200100   || response.data.code == 200102 ||response.data.code ==200101) {



        return   response

      }


      Toast(response.data.mes);

    }



    return response;
  },
  (error) => {
    // return Promise.reject(error);
  }
);
export default request;